// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1_XHH","colMin":"styles_colMin__2XBcc","colCheckbox":"styles_colCheckbox__3f37n"};